<template>
	<aside>
		<div class='topMenu' :class='topTransparent'>
			<div class='topMenu-inner'>
				<img class='top-logo' src="../assets/images/logo.png">
				<div class='right-item'>
					<ul class='menu-list'>
						<div class='top-line' :class='barClass' :style="barStyle"></div>
						<li v-for='(value, key, index) in list' :key='index' :class="{ active: active === index }" @click.stop="toggle(key, index)">
							<span>{{value}}</span>
							<div class='about-box' v-if='index === 2' :style="{display: isAppear}">
								<!-- <div class='arrow'></div> -->
								<ul class='about-us-item'>
									<!-- <div class='item-ink' :class='inkClass' :style="inkStyle"></div> -->
									<li v-for='(val, key, num) in items' :key='num' :class="{ change: change === num }" @click.stop="toogleItem(key, num)" @mouseover='enterItem(key, num)' @mouseout='outItem(key, num)'>
										{{val}}
									</li>
								</ul>
							</div>
						</li>
					</ul>
					<div class="downloadApp">
            <p>免费咨询服务热线</p>
            <span>400-1556-256</span>
          </div>
				</div>
			</div>
		</div>
	</aside>
</template>

<script>
  export default {
    data () {
      return {
        list: {
          home: '首页',
          business: '业务介绍',
          aboutUs: '关于我们'
        },
        items: {
          intro: '公司介绍',
          news: '新闻动态',
          hire: '招贤纳士',
          contact: '联系我们'
        },
        active: 0,
        change: 0,
        currentIndex: '',
        number: '',
        direction: '',
        currentItems: '',
        ItemDirection: '',
        num: '',
        isAppear: 'none',
        topTransparent: ''
      }
    },
    methods: {
      toggle (key, index) {
        this.active = index
        this.currentIndex = this.active
        this.isAppear = this.active === 2 ? 'block' : 'none'
        if (key !== 'aboutUs') {
          this.$router.push(`/${key}`)
          setTimeout(function(){
            document.getElementById('page-top').scrollIntoView()
          },1)
        }
      },
      toogleItem (key, num) {
        if (key === 'hire') {
          window.open('https://www.lagou.com/gongsi/103241.html')
        } else {
          this.$router.push(`/aboutUs/${key}`)
        }
        this.isAppear = 'none'
      },
      enterItem (key, num) {
        this.change = num
        this.currentItems = this.change
        // console.log(num)
      },
      outItem (key, num) {
        // this.change = num
        // this.currentItems = this.change
      },
      updateIndex () {
        this.number = Object.keys(this.list).length
        this.currentIndex = this.active
        this.num = Object.keys(this.items).length
        this.currentItems = this.change
      },
      downloadApp () {
        this.active = 0
        this.currentIndex = 0
        this.$router.push(`/home`)
        setTimeout(function(){
          document.getElementById('downloadApp').scrollIntoView()
        },1)
      },
      listenUrl () {
        var url = location.hash
        switch (url) {
          case '#/aboutUs/intro':
            this.currentItems = 0
            this.currentIndex = 2
            break
          case '#/aboutUs/news':
            this.currentItems = 1
            this.currentIndex = 2
            break
          case '#/aboutUs/contact':
            this.currentItems = 3
            this.currentIndex = 2
            break
          case '#/home':
            this.currentIndex = 0
            break
          case '#/business':
            this.currentIndex = 1
            break
        }
      }
    },
    computed: {
      barClass () {
        return {
          'forward': this.direction === 'forward',
          'backward': this.direction === 'backward'
        }
      },
      barLeft () {
        return `${this.currentIndex * (100 / this.number) + 5}%`
      },
      barRight () {
        return `${(this.number - this.currentIndex - 1) * (100 / this.number) + 5}%`
      },
      barStyle () {
        const commonStyle = {
          left: this.barLeft,
          right: this.barRight
        }
        return commonStyle
      },
      inkClass () {
        return {
          'downward': this.ItemDirection === 'downward',
          'upward': this.ItemDirection === 'upward'
        }
      },
      inkTop () {
        return `${this.change * (100 / this.num)}%`
      },
      inkBottom () {
        return `${(this.num - this.change - 1) * (100 / this.num)}%`
      },
      inkStyle () {
        const itemStyle = {
          top: this.inkTop,
          bottom: this.inkBottom
        }
        return itemStyle
      }
    },
    watch: {
      '$route': 'listenUrl',
      currentIndex (newIndex, oldIndex) {
        // console.log('oldIndex ' + oldIndex)
        // console.log('newIndex ' + newIndex)
        this.direction = newIndex > oldIndex ? 'forward' : 'backward'
      },
      currentItems (newItem, oldItem) {
        // console.log('oldItem ' + oldItem)
        // console.log('newItem ' + newItem)
        this.ItemDirection = newItem > oldItem ? 'downward' : 'upward'
      }
    },
    mounted () {
      this.updateIndex()
      var _this = this
      window.document.addEventListener('click', function () {
        _this.isAppear = 'none'
      })
      var addressUrl = location.hash
      switch (addressUrl) {
        case '#/home':
          this.currentIndex = 0
          break
        case '#/business':
          this.currentIndex = 1
          break
        case '#/aboutUs/intro':
          this.currentIndex = 2
          break
        case '#/aboutUs/news':
          this.currentIndex = 2
          break
        case '#/aboutUs/contact':
          this.currentIndex = 2
          break
      }
    },
    updated () {
     // this.topTransparent = location.hash === '#/home' ? 'top-transparent' : '' // 除了首页透明导航栏
      var url = location.hash
      switch (url) {
        case '#/aboutUs/intro':
          this.currentItems = 0
          break
        case '#/aboutUs/news':
          this.currentItems = 1
          break
        case '#/aboutUs/contact':
          this.currentItems = 3
          break
      }
    }
  }
</script>

<style lang='scss' scoped>
	@import '../assets/style/veriable.scss';

	.topMenu {
		height: $topMenuHeight;
		background-color: $topMenuBackColor;
		position: fixed;
		top: 0;
		width: 100%;
		z-index: 233;
		&.top-transparent {
		    background-color: rgba(255, 255, 255, .5);
		}
		.topMenu-inner {
			height: 100%;
			width: 75%;
			min-width: $topMenuInnerWidth;
			margin: 0 auto;
			display: flex;
			flex-flow: row;
			justify-content: space-between;
			align-items: center;
			.top-logo {
				height: $topMenuInnerImgHeight;
        width: 209px;
			}
			.right-item {
				display: flex;
				.downloadApp {
          cursor: pointer;
          padding-left: 16px;
          display: flex;
          flex-direction: column;
          // justify-content: center;
          p {
            font-size: 12px;
            color: #FF2A18;
            width: 100%;
            text-align: left;
            padding-left: 28px;
            padding-top: 10px;
          }
					span {
						// padding: 5px;
						padding-left: 28px;
						background: url(../assets/imgs/phone.png) no-repeat;
            background-position: left;
            font-size: 18px;
					}
				}
			}
			.menu-list {
				height: 100%;
				display: flex;
				position: relative;
				.top-line {
					position: absolute;
					top: 75px;
					height: 4px;
					background-color: $topMenuInnerItemColor;
					&.forward {
						transition: right $effect-duration $easing-in-out,
      					left $effect-duration $easing-in-out $effect-duration * 0.3;
					}
					&.backward {
						transition: right $effect-duration $easing-in-out $effect-duration * 0.3,
      					left $effect-duration $easing-in-out;
					}
				}
				li {
					width: $topMenuInnerItemWidth;
					height: 100%;
					cursor: pointer;
					padding: 4px 0;
					position: relative;
					span {
						border-top: 3px solid transparent;
						display: inline-block;
						height: 100%;
						padding: 20px 0;
						font-size: 20px;
					}
					&.active > span {
						/*border-top-color: $topMenuInnerItemColor;*/
					}
					.about-box {
						padding: 27px 0;
						background-color: rgba(0, 0, 0, .6);
						display: none;
						position: absolute;
						top: $topMenuHeight - 1;
						animation: fadeInBottom .3s;
						&.appear {
							display: block;
						}
						.arrow {
							position: absolute;
							top: 0;
							left: 50%;
							right: 50%;
							transform: translate(-50%, -100%);
							border-left: 6px solid transparent;
							border-right: 6px solid transparent;
							border-bottom: 6px solid rgba(0, 0, 0, .6);
						}
					}
					.about-us-item {
						color: #fff;
						font-size: 16px;
						position: relative;
						.item-ink {
							position: absolute;
							top: 0;
							width: 100%;
							background-color: $topMenuInnerItemColor;
							&.upward {
								transition: top $effect-duration * .5 $easing-in-out,
		      					bottom $effect-duration * .5 $easing-in-out $effect-duration * 0.3;
							}
							&.downward {
								transition: top $effect-duration * .5 $easing-in-out $effect-duration * 0.3,
		      					bottom $effect-duration * .5 $easing-in-out;
							}
						}
						.change {
							background-color: $topMenuInnerItemColor;
						}
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// topmenu.vue?fa23f826